import { ErrorBoundary } from '@/components/ErrorBoundary/ErrorBoundaryReactRouter';
import { convertRouteModule } from '@/utils/convert-route-module';
import { RouteObject } from 'react-router';

const stripeAccountsModalRoutes: RouteObject[] = [
  {
    path: ':stripeAccountId/edit',
    lazy: () =>
      import('@/views/payments/components/stripeAccounts/EditStripeAccountDialog').then(
        convertRouteModule
      ),
    ErrorBoundary,
    HydrateFallback: () => null,
  },
  {
    path: ':stripeAccountId/complete',
    lazy: () =>
      import('@/views/payments/components/stripeAccounts/PostOnboardingStripeAccountDialog').then(
        convertRouteModule
      ),
    ErrorBoundary,
    HydrateFallback: () => null,
  },
];

export { stripeAccountsModalRoutes };
